<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <div
                        class="row col-12 pb-3 px-0 m-0 d-flex justify-content-between"
                    >
                        <h4 class="font-weight-bold">Primeira Observação</h4>
                    </div>
                    <load mode="table" v-if="loading" />
                    <form @submit.prevent="submit">
                        <div class="row">
                            <form-select
                                v-model="primeiraObservacao.condicao_higiene"
                                :itens="$root.arrays.pergunta"
                                label="A criança/adolescente encontrava-se em boas condições de higiene? "
                                :required="true"
                            /><form-select
                                v-model="primeiraObservacao.chegou_agitada"
                                :itens="$root.arrays.pergunta"
                                label="A criança/adolescente estava agitada ao chegar na unidade?"
                                :required="true"
                            /><form-select
                                v-model="primeiraObservacao.chegou_chorando"
                                :itens="$root.arrays.pergunta"
                                label="A criança/adolescente estava chorando ao chegar na unidade? "
                                :required="true"
                            /><form-select
                                v-model="primeiraObservacao.dificuldade_dormir"
                                :itens="$root.arrays.pergunta"
                                label="A criança/adolescente apresentou dificuldade para dormir?"
                                :required="true"
                            /><form-select
                                v-model="primeiraObservacao.enurese_noturna"
                                :itens="$root.arrays.pergunta"
                                label="A criança/adolescente apresentou enurese noturna? "
                                :required="true"
                            /><form-select
                                v-model="primeiraObservacao.vestigio_psicoativo"
                                :itens="$root.arrays.pergunta"
                                label="A criança adolescente apresentava vestígios do uso de alguma substância psicoativa?"
                                :required="true"
                            /><form-select
                                v-model="primeiraObservacao.violencia_fisica"
                                :itens="$root.arrays.pergunta"
                                label="A criança adolescente apresentava algum sinal de violência física?"
                                :required="true"
                            /><form-select
                                v-model="primeiraObservacao.violacia_sexual"
                                :itens="$root.arrays.pergunta"
                                label="A criança adolescente apresentava algum sinal de violência sexual? "
                                :required="true"
                            /><form-select
                                v-model="
                                    primeiraObservacao.vivencia_negligencia
                                "
                                :itens="$root.arrays.pergunta"
                                label="A criança adolescente apresentava aspectos que indicam a vivência de negligência?"
                                :required="true"
                            />
                        </div>

                        <h3 class="mt-3">Aspectos pessoais observados</h3>
                        <div class="row">
                            <form-select
                                v-model="primeiraObservacao.aspectos_pessoais"
                                :itens="
                                    $root.arrays.acolhimento_aspectos_pessoais
                                "
                                label="Aspectos pessoais observados:"
                                :multiple="true"
                            />
                            <form-input-tag
                                v-model="
                                    primeiraObservacao.aspectos_pessoais_outros
                                "
                                label="Outros (Aperte ENTER, para inserir um ou mais)"
                            />
                        </div>
                        <div class="row pt-4 px-0 d-flex justify-content-end">
                            <div class="col-auto px-2 text-right">
                                <button
                                    class="btn btn-success btn-submit"
                                    type="submit"
                                >
                                    <i class="mdi mdi-content-save" />
                                    {{ $t("Salvar") }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            loading: false,
            primeiraObservacao: {},
        };
    },
    watch: {
        item() {
            if (this.item.primeiraObservacao != null) {
                this.primeiraObservacao = this.item.primeiraObservacao;
            }
        },
    },
    mounted() {
        if (this.item.primeiraObservacao != null) {
            this.primeiraObservacao = this.item.primeiraObservacao;
        }
    },
    methods: {
        submit() {
            this.item.primeiraObservacao = this.primeiraObservacao;
            this.$emit("submit");
        },
    },
};
</script>
